import { Link, NavLink, Outlet } from "react-router";
import {
  ShieldCheck,
  ArrowLeft,
  Users,
  AlertTriangle,
  BarChart3,
  FileQuestion,
  Hammer,
  FolderOpen,
  FileSearch,
} from "lucide-react";

import { cn } from "@/lib/utils";
import { Toaster } from "@/components/ui/sonner";

// @ts-ignore
import licitigo_logo from "../../assets/licitigo_logo.svg";

const ADMIN_TABS = [
  { to: "/admin/users", label: "Usuarios", icon: Users },
  { to: "/admin/metrics", label: "Métricas", icon: BarChart3 },
  {
    to: "/admin/contractings-errors",
    label: "Errores de procesamiento",
    icon: AlertTriangle,
  },
  {
    to: "/admin/contractings-missing-files",
    label: "Documentos faltantes",
    icon: FileQuestion,
  },
  { to: "/admin/bid-documents", label: "Bases por revisar", icon: FileSearch },
  { to: "/admin/work-advisory", label: "Informe de obras", icon: Hammer },
  {
    to: "/admin/company-documents",
    label: "Documentos de empresa",
    icon: FolderOpen,
  },
];

export default function AdminLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="sticky top-0 z-40 flex w-full items-center justify-between border-b bg-card/70 px-4 py-3 backdrop-blur-md md:px-6">
        <div className="flex items-center gap-3">
          <Link to="/dashboard" className="flex items-center">
            <img src={licitigo_logo} alt="Licitigo" className="h-8 w-auto" />
          </Link>
          <span className="flex items-center gap-1.5 rounded-full bg-primary/10 px-2.5 py-1 text-xs font-bold text-primary">
            <ShieldCheck className="h-3.5 w-3.5" />
            Admin
          </span>
        </div>
        <Link
          to="/dashboard"
          className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver a la app
        </Link>
      </header>

      <nav className="flex w-full items-center gap-1 border-b bg-card/40 px-4 py-2 md:px-6">
        {ADMIN_TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium transition-colors",
                isActive
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:bg-accent hover:text-foreground",
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>

      <Toaster richColors position="top-right" />
    </div>
  );
}
